<script lang="ts">
    import { readable } from "svelte/store";
    import { getColorByString } from "../../Utils/ColorGenerator";
    import type { PictureStore } from "../../Stores/PictureStore";

    export let pictureStore: PictureStore | undefined;
    export let fallbackName = "A";
    export let color: string | null = null;
    export let isChatAvatar = false;

    const emptyPictureStore: PictureStore = readable<string | undefined>(undefined);

    let resolvedPictureStore: PictureStore;
    let pictureUrl: string | undefined;
    let lastPictureUrl: string | undefined;
    let pictureLoadError = false;
    let hasPicture = false;

    $: resolvedPictureStore = pictureStore ?? emptyPictureStore;
    $: pictureUrl = $resolvedPictureStore;
    $: if (pictureUrl !== lastPictureUrl) {
        lastPictureUrl = pictureUrl;
        pictureLoadError = false;
    }
    $: hasPicture = Boolean(pictureUrl) && !pictureLoadError;

    function onPictureError(): void {
        pictureLoadError = true;
    }
</script>

{#if hasPicture}
    <div
        class:chatAvatar={isChatAvatar}
        class="relative h-7 w-7 rounded-md overflow-hidden shrink-0"
        draggable="false"
        style:background-color={`${color ? color : getColorByString(fallbackName)}`}
    >
        <div class="translate-y-[2px] -translate-x-[2px]">
            <img
                src={pictureUrl}
                alt="User avatar"
                class="avatar-image w-8 h-8 object-cover object-center"
                draggable="false"
                on:error={onPictureError}
            />
        </div>
    </div>
{:else}
    <div
        class:chatAvatar={isChatAvatar}
        class="rounded-md h-7 w-7 text-center uppercase text-white flex items-center justify-center font-bold shrink-0"
        draggable="false"
        style:background-color={`${color ? color : getColorByString(fallbackName)}`}
    >
        {fallbackName.charAt(0)}
    </div>
{/if}

<style>
    .avatar-image {
        image-rendering: auto;
    }

    .chatAvatar {
        border-style: solid;
        border-color: rgb(27 42 65 / 0.95);
        border-width: 1px;
    }
</style>
